// extracted by mini-css-extract-plugin
export var ProjectsContainer = "ProjectCard-module--ProjectsContainer--BpA2m";
export var ProjectCard = "ProjectCard-module--ProjectCard--pN6MT";
export var full = "ProjectCard-module--full--caEFp";
export var top = "ProjectCard-module--top--fkS7x";
export var bottom = "ProjectCard-module--bottom--op63s";
export var TextContent = "ProjectCard-module--TextContent--WizV2";
export var tags = "ProjectCard-module--tags--FnvX8";
export var title = "ProjectCard-module--title--WhQk6";
export var underline = "ProjectCard-module--underline--O0GYZ";